
import { isObject, toArray } from 'vessel/utils'

export default {
  name: 'VsPanel',
  inheritAttrs: false,
  props: {
    title: {
      type: [String, Object],
      default: null
    },
    link: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    expand: {
      type: Boolean,
      default: false
    },
    stretch: {
      type: Boolean,
      default() {
        return this.expand
      }
    },
    extend: {
      type: [Boolean, String, Array],
      default: false
    },
    background: {
      type: [String, Object],
      default: null
    },
    outline: {
      type: [Boolean, String, Object],
      default: null
    },
    gutter: {
      type: [Boolean, String, Object],
      default: null
    },
    border: {
      type: [Boolean, String, Object],
      default: null
    },
    shadow: {
      type: [Boolean, String, Object],
      default: null
    },
    radius: {
      type: [Boolean, String, Object],
      default: null
    },
    scrollable: {
      type: Boolean,
      default: null
    }
  },
  vessel: {
    panel: {
      $attrs: 'all',
      $background: 'backgroundColor',
      width: 'full',
      $shadow: 'shadow',
      $outline: {
        borderWidth(val) {
          return val ? 1 : null
        },
        borderColor(val) {
          return val ? val : null
        }
      },
      $radius: {
        borderRadius(val) {
          return val
        },
        overflow(val) {
          return val ? 'hidden' : null
        }
      },
      $gutter: {
        padding(val) {
          return val == true ? 'sm' : val
        }
      }
    },
    contentSlot: {
      $scrollable: {
        overflowY(val) {
          return val ? 'auto' : null
        }
      }
    },
    content: {
      $extend: 'contentSlot',
      paddingY: 'sm',
      $expand: {
        paddingTop(val) {
          const expand = val && !this.hasHeader
          return this.extends('content') || expand ? '0' : null
        },
        paddingBottom(val) {
          const expand = val && !this.hasFooter
          return this.extends('content') || expand ? '0' : null
        }
      },
      $stretch: {
        paddingX(val) {
          return this.extends('content') || val ? null : 'sm'
        }
      }
    },
    header: {
      $expand: {
        paddingTop(val) {
          return this.extends('header') || val ? null : 'sm'
        }
      },
      $stretch: {
        paddingX(val) {
          return this.extends('header') || val ? null : 'sm'
        }
      },
      $border: {
        borderBottomWidth(val) {
          return val ? 1 : null
        },
        borderColor(val) {
          return val
        },
        paddingBottom(val) {
          return !this.extends('header') && val ? 'sm' : null
        }
      }
    },
    footer: {
      $expand: {
        paddingBottom(val) {
          return this.extends('footer') || val ? null : 'sm'
        }
      },
      $stretch: {
        paddingX(val) {
          return this.extends('footer') || val ? null : 'sm'
        }
      },
      $border: {
        borderTopWidth(val) {
          return val ? 1 : null
        },
        borderColor(val) {
          return val
        },
        paddingTop(val) {
          return !this.extends('footer') && val ? 'sm' : null
        }
      }
    },
    link: {
      display: 'block',
      width: 'full',
      height: 'full'
    }
  },
  computed: {
    hasHeader() {
      return this.title || this.$slots.header
    },
    hasFooter() {
      return this.$slots.footer
    },
    contentClass() {
      return this.$slots.content
        ? this.$vessels.contentSlot
        : this.$vessels.content
    }
  },
  methods: {
    extends(name) {
      return this.extend == true || toArray(this.extend).includes(name)
    },
    nodeAttrs(prop, tag) {
      const custom = isObject(prop) ? prop : { html: prop }
      return { tag: (tag || 'div'), ...custom }
    }
  }
}
